import loadable from '@loadable/component';

export const Rules = loadable(
  () => import('@plone/volto/components/manage/Rules/Rules'),
);
